import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles } from "@mui/styles";
import {
  Grid,
  Alert,
  Backdrop,
  CircularProgress,
  Box,
  //Typography,
  List,
  ListItem,
  //Radio,
  //RadioGroup,
  //FormControl,
  //FormLabel,
  //Paper,
  Divider,
} from "@mui/material";
import {
  DoDisturbOnOutlined,
  CreditCard,
  // Payment
} from "@mui/icons-material";
import axios from "axios";
import Moment from "moment";

import StripePaymentFormAPI from "./StripePaymentFormAPI";
import FrequentQuestions from "../Dialog/FrequentQuestions";

import logo from "assets/img/logo.png";
import typeCard from "assets/img/marcas-tarjetas.png";
import errorImg from "assets/img/error.png";
import successImg from "assets/img/success.gif";
import pendingImg from "assets/img/pending.png";
import loaderGif from "assets/img/loading.gif";

import { cardBodyStyle, ButtonStyle0 } from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

// Componente para mostrar cada método de pago
/*const PaymentMethodOption = ({ method, selected, onSelect }) => {
  return (
    <Paper
      elevation={selected ? 2 : 0}
      sx={{
        p: 2,
        border: selected ? "2px solid #1976d2" : "1px solid #ddd",
        borderRadius: 2,
        cursor: "pointer",
        backgroundColor: selected ? "#f0f8ff" : "white",
        "&:hover": {
          backgroundColor: "#f5f5f5",
        },
        mb: 1,
      }}
      onClick={() => onSelect(method.id)}
    >
      <Box sx={{ display: "flex" }}>
        <Radio
          checked={selected}
          onChange={() => onSelect(method.id)}
          value={method.id}
          name="payment-method"
        />
        <Box sx={{ ml: 2, display: "flex", textAlign: "left", flex: 1 }}>
          <Box sx={{ mr: 2 }}>{method.icon}</Box>
          <Box>
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              sx={{ color: "#000" }}
            >
              {method.name}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ color: "#000" }}
            >
              {method.description}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};*/

export default function PaymentApiConnection(props) {
  const classes = useStyles();

  const [paymentTransactionStripe, setPaymentTransactionStripe] =
    useState(null);
  const [OpenPay, setOpenPay] = useState(false);
  const [accept, setAccept] = useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [rows, setRows] = useState(null);
  const [Loader, setLoader] = useState(true);
  const [state, setState] = React.useState({
    YES_termsConditions: false,
    YES_dataProtectionPolicies: false,
  });
  const [alert, setAlert] = useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
    img: "",
  });
  const [openFrequentQuestion, setOpenFrequentQuestion] = useState(false);
  const [disabledPay, setDisabledPay] = React.useState(false);
  const [paymentMethod, setPaymentMethod] = useState("stripe"); // Stripe por defecto
  const [showStripeForm, setShowStripeForm] = useState(false);
  const [stripeClientSecret, setStripeClientSecret] = useState("");
  const [stripeLoading, setStripeLoading] = useState(false);

  const { urlServices, LightboxPlaceToPay } = useContext(UrlServicesContext);

  const { id } = useParams();

  // Métodos de pago disponibles
  const paymentMethods = [
    {
      id: "stripe",
      name: "Stripe",
      description: "Paga con tarjetas de crédito de forma segura",
      icon: <CreditCard sx={{ fontSize: 30, color: "#635bff" }} />,
    },
    /*{
      id: "placetopay",
      name: "PlaceToPay",
      description: "Paga con tarjetas débito, crédito o transferencias",
      icon: <Payment sx={{ fontSize: 30, color: "#1976d2" }} />,
    },*/
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RowsDatas();
  }, []);

  // Cargar el script del Lightbox en el componente
  useEffect(() => {
    const script = document.createElement("script");
    script.src = LightboxPlaceToPay;
    script.async = true;
    document.body.appendChild(script);

    // Limpiar el script al desmontar el componente
    return () => {
      document.body.removeChild(script);
    };
  }, [disabledPay]);

  const RowsDatas = async () => {
    setLoader(true);

    try {
      const response = await axios.get(
        `${urlServices}payment-link/transaction/${id}`,
      );

      if (response.status === 200) {
        const payment = response.data.data.paymentTransactions.some(
          (transaction) => transaction.status === 1,
        );

        if (!payment) {
          let paymentInfo = response.data.data.paymentTransactions.some(
            (transaction) => transaction.status === 3,
          );

          if (paymentInfo) {
            let paymentInfoData = response.data.data.paymentTransactions.find(
              (transaction) => transaction.status === 3,
            );
            setError(true);
            setMensageSystem(
              `Esta transacción está aún en estado PENDIENTE. ref: ${paymentInfoData.reference}`,
            );
          } else {
            setRows(response.data.data);
            setAccept(response.data.data.acceptTerms ? true : false);
          }
        } else {
          setError(true);
          setMensageSystem("No hay registros para mostrar.");
        }
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setMensageSystem("Registro no encontrado.");
        setError(true);
      } else if (error.response?.status === 500) {
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    } finally {
      setLoader(false);
    }
  };

  const submitAcceptSave = (data, value) => {
    const dataValue = {
      [data]: value,
    };

    axios
      .put(`${urlServices}payment-link/web/${rows.id}`, dataValue)
      .then((response) => {})
      .catch((e) => {
        console.log(e);
      });
  };

  function getDataValue() {
    return {
      document: rows.documentId,
      documentType: rows.typeDocument,
      name: rows.name,
      surname: rows.lastName,
      email: rows.email,
      mobile: `${rows.phone}`,
      subTotal: rows.subTotal,
      iva: rows.iva,
      ivaTotal: rows.ivaSubtotal,
      payTotal: rows.total,
      paymentLinkId: rows.id,
      clientHost: rows.client.companyName,
      clientEmailHost: rows.client.email,
      description: "PAGO POR API",
    };
  }

  const createPay = () => {
    setDisabledPay(true);
    const dataValue = getDataValue();

    axios
      .post(`${urlServices}placetopay/create-pay`, dataValue)
      .then((response) => {
        openLightbox(response.data);
      })
      .catch((error) => {
        setDisabledPay(false);
        handleError(error);
      });
  };

  // Función para abrir el Lightbox
  const openLightbox = (valuesData) => {
    if (window.P) {
      window.P.on("response", function (response) {
        submitRequestPay(valuesData.paymentTransaction);
      });

      // Iniciar el Lightbox
      window.P.init(valuesData.data.processUrl);
    }
  };

  const submitRequestPay = async (paymentTransaction) => {
    try {
      setOpenPay(true);
      setLoader(true);

      const response = await axios.post(
        `${urlServices}placetopay/view-pay/${paymentTransaction.requestIdTransaction}`,
      );
      if (response.status === 201) {
        const status = response.data.data.status;
        if (status.status === "REJECTED") {
          setAlert({
            openAlert: true,
            errorAlert: "error",
            mensaje: "Tu pago fue RECHAZADO",
            reference: response.data.data.request.payment.reference,
            date: Moment(response.data.data.status.date).format("DD-MM-YYYY"),
            price: response.data.data.request.payment.amount.total,
            receipt: null,
            authorization: null,
            img: errorImg,
          });
        } else if (status.status === "APPROVED") {
          setAlert({
            openAlert: true,
            errorAlert: "success",
            mensaje: "Tu pago ha sido APROBADO y registrado exitosamente",
            reference: response.data.data.request.payment.reference,
            date: Moment(response.data.data.status.date).format("DD-MM-YYYY"),
            price: response.data.data.request.payment.amount.total,
            receipt: response.data.data.payment[0].receipt,
            authorization: response.data.data.payment[0].authorization,
            img: successImg,
          });
        } else if (status.status === "PENDING") {
          setAlert({
            openAlert: true,
            errorAlert: "warning",
            mensaje: "Tu pago está en estado PENDIENTE",
            reference: response.data.data.request.payment.reference,
            date: Moment(response.data.data.status.date).format("DD-MM-YYYY"),
            price: response.data.data.request.payment.amount.total,
            receipt: null,
            authorization: null,
            img: pendingImg,
          });
        }
        submitSave(paymentTransaction.id, response.data.data);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const submitSave = async (id, data) => {
    const dataValue = {
      responseTransaction: JSON.stringify(data),
      status:
        data.status.status === "APPROVED"
          ? 1
          : data.status.status === "REJECTED"
            ? 0
            : 3,
    };

    try {
      const response = await axios.put(
        `${urlServices}payment-transaction/${id}`,
        dataValue,
      );
      if (response.status === 200) {
        await sendMail(data);

        if (data.status.status === "APPROVED") {
          await updateStatusLink();
          await sendMailClientHost(data);
        }

        setLoader(false);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const updateStatusLink = async () => {
    try {
      const response = await axios.put(
        `${urlServices}payment-link/update-transaction/${rows.id}`,
        { status: 3 },
      );
      if (response.status === 200) {
      }
    } catch (error) {
      handleError(error);
    }
  };

  const sendMail = async (transaccion) => {
    try {
      const values = {
        data: JSON.stringify(getDataValue()),
        status: transaccion.status.status,
        // reference: transaccion.request.payment.reference,
        reference: paymentTransactionStripe.reference,
        date: Moment(transaccion.status.date).format("DD-MM-YYYY"),
        receipt: transaccion.payment ? transaccion.payment[0]?.receipt : null,
        authorization: transaccion.payment
          ? transaccion.payment[0]?.authorization
          : null,
      };

      const response = await axios.post(
        `${urlServices}payment-link/mail-transaction`,
        values,
      );
      if (response.status === 200) {
      }
    } catch (error) {
      handleError(error);
    }
  };

  const sendMailClientHost = async (transaccion) => {
    try {
      const values = {
        data: JSON.stringify(getDataValue()),
        status: transaccion.status.status,
        //reference: transaccion.request.payment.reference,
        reference: paymentTransactionStripe.reference,
        date: Moment(transaccion.status.date).format("DD-MM-YYYY"),
        receipt: transaccion.payment ? transaccion.payment[0]?.receipt : null,
        authorization: transaccion.payment
          ? transaccion.payment[0]?.authorization
          : null,
      };

      const response = await axios.post(
        `${urlServices}payment-link/mail-transaction-client-host`,
        values,
      );
      if (response.status === 200) {
      }
    } catch (error) {
      handleError(error);
    }
  };

  const submitAccept = () => {
    let date = JSON.stringify({
      status: "accept",
      date: Moment().format("DD-MM-YYYY"),
    });

    submitAcceptSave("acceptTerms", date);
    setAccept(true);
    processPayment();
  };

  const handleChangeCheckbox = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  const handleCloseFrequentQuestion = () => {
    setOpenFrequentQuestion(false);
  };

  // Manejo común de errores
  const handleError = (error) => {
    if (error.response?.status === 404) {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Registro no encontrado.");
      setError(true);
    } else if (error.response?.status === 500) {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Error en la consulta con el servidor.");
      setError(true);
    } else {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Error al realizar la solicitud.");
      setError(true);
    }
    setLoader(false);
  };

  // Función para crear pago con Stripe
  const createStripePayment = async () => {
    setStripeLoading(true);
    try {
      const dataValue = getDataValue();

      const response = await axios.post(
        `${urlServices}stripe/create-payment`,
        dataValue,
      );

      setPaymentTransactionStripe(response.data);
      setStripeClientSecret(response.data.clientSecret);
      setShowStripeForm(true);
    } catch (error) {
      console.error("Error creating Stripe payment:", error);
      setMensageSystem("Error al crear el pago con Stripe");
      setError(true);
    } finally {
      setStripeLoading(false);
    }
  };

  // Función para manejar éxito de pago con Stripe
  const handleStripeCancel = () => async () => {
    try {
      setShowStripeForm(false);

      const data = {
        requestId: paymentTransactionStripe.paymentIntentId,
        status: {
          status: "REJECTED",
          message: "La petición ha sido cancelada por el usuario",
          date: Moment().format("YYYY-MM-DD HH:mm:ss"),
        },
      };

      await submitSave(paymentTransactionStripe?.paymentTransaction?.id, data);
      setShowStripeForm(false);
    } catch (error) {
      console.error("Error handling Stripe cancel:", error);
    }
  };

  // Función para manejar pago con Stripe
  const handleStripeSuccess = async (values) => {
    try {
      setShowStripeForm(false);
      setOpenPay(true);
      setAlert({
        openAlert: true,
        errorAlert: "success",
        mensaje: "Tu pago ha sido APROBADO y registrado exitosamente",
        date: Moment(values.created).format("DD-MM-YYYY"),
        reference: paymentTransactionStripe.reference,
        price: values.amount,
        receipt: values.paymentIntentId,
        img: successImg,
      });

      const data = {
        requestId: paymentTransactionStripe.paymentIntentId,
        status: {
          status: "APPROVED",
          message: "La petición ha sido aprobada exitosamente",
          date: Moment(values.created).format("YYYY-MM-DD HH:mm:ss"),
        },
        paymentMethod: values.paymentMethod,
        price: values.amount,
        currency: values.currency,
      };

      submitSave(paymentTransactionStripe?.paymentTransaction?.id, data);
      // await RowsDatas();
    } catch (error) {
      console.error("Error handling Stripe success:", error);
    }
  };

  // Procesar el pago según el método seleccionado
  const processPayment = () => {
    if (paymentMethod === "stripe") {
      createStripePayment();
    } else if (paymentMethod === "placetopay") {
      createPay();
    }
  };

  // Manejar cambio de método de pago
  const handlePaymentMethodChange = (methodId) => {
    setPaymentMethod(methodId);
  };

  const style = {
    py: 0,
    width: "100%",
    maxWidth: 360,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    backgroundColor: "background.paper",
  };

  // Agregar al final del componente PaymentApiConnection
  useEffect(() => {
    // Enviar mensaje al padre cuando el pago sea exitoso
    if (OpenPay) {
      window.parent.postMessage(
        {
          type: "PAYMENT_COMPLETED",
          status: "success",
          paymentLinkId: rows?.id,
          reference: rows?.reference,
        },
        "*",
      );
    }
  }, [OpenPay]);

  // También enviar mensaje cuando hay error
  useEffect(() => {
    if (error) {
      window.parent.postMessage(
        {
          type: "PAYMENT_FAILED",
          status: "error",
          message: mensageSystem,
        },
        "*",
      );
    }
  }, [error, mensageSystem]);

  return (
    <div>
      <center>
        <Grid
          container
          spacing={1}
          sx={{
            minWidth: 200,
            width: {
              xs: "90%", // 90% en pantallas extra pequeñas
              sm: "80%", // 80% en pantallas pequeñas
              md: "60%", // 60% en pantallas medianas
              lg: "40%", // 40% en pantallas grandes (mantienes tu 40% original)
            },
            mx: "auto", // Margen horizontal automático (centrado)
            my: 1, // Margen vertical opcional
          }}
        >
          <Grid item xs={12} sm={12}>
            {error && <Alert severity="error">{mensageSystem}</Alert>}
          </Grid>
          {error ? (
            <Grid item xs={12} sm={12} sx={{ my: 15 }}>
              <center>
                <DoDisturbOnOutlined sx={{ fontSize: 46, color: "#ccc" }} />
                <br></br>
                <b
                  style={{
                    fontSize: 18,
                    margin: "5px 0 70px 0",
                    color: "#ccc",
                  }}
                >
                  No hay registros para mostrar
                </b>
              </center>
            </Grid>
          ) : Loader ? (
            <Grid item xs={12} sm={12}>
              <center>
                <img
                  alt="loaderGif"
                  src={loaderGif}
                  style={{ width: 60, margin: "20% 0" }}
                />
              </center>
            </Grid>
          ) : (
            <>
              {OpenPay ? (
                <Grid
                  container
                  spacing={2}
                  className={classes.containerProfile}
                  sx={{ paddingBottom: 8 }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={alert.img}
                      alt="type"
                      style={{ width: 180, marginBottom: 20 }}
                    />
                    <Alert
                      severity={
                        alert.errorAlert === "success" ? "success" : "error"
                      }
                      icon={false}
                      sx={{ fontSize: 20 }}
                    >
                      {alert.mensaje}
                    </Alert>
                    <br></br>
                    <List sx={style}>
                      <ListItem>
                        <Grid container sx={{ color: "#000" }}>
                          {/*<Grid item xs={6} sm={6}>
                            <b style={{ marginRight: 50 }}>Referencia</b>
                          </Grid>
                          <Grid item xs={6} sm={6}>
                            <span style={{ float: "right" }}>
                              <ListItemText primary={alert.reference} />
                            </span>
                          </Grid>*/}

                          <Grid item xs={8} sm={8}>
                            <b>Regresando al comercio</b>
                          </Grid>
                          <Grid item xs={4} sm={4}>
                            <img
                              alt="loaderGif"
                              src={loaderGif}
                              style={{ width: 60 }}
                            />
                          </Grid>
                        </Grid>
                      </ListItem>
                      {/*alert.receipt && (
                    <>
                      <Divider component="li" />
                      <ListItem>
                        <Grid container sx={{ color: "#000" }}>
                          <Grid item xs={6} sm={6}>
                            <b style={{ marginRight: 50 }}>Recibo</b>
                          </Grid>
                          <Grid item xs={6} sm={6}>
                            <span style={{ float: "right" }}>
                              <ListItemText primary={alert.receipt} />
                            </span>
                          </Grid>
                        </Grid>
                      </ListItem>
                      <Divider component="li" />
                      <ListItem>
                        <Grid container sx={{ color: "#000" }}>
                          <Grid item xs={6} sm={6}>
                            <b style={{ marginRight: 50 }}>Autorización</b>
                          </Grid>
                          <Grid item xs={6} sm={6}>
                            <span style={{ float: "right" }}>
                              <ListItemText primary={alert.authorization} />
                            </span>
                          </Grid>
                        </Grid>
                      </ListItem>
                    </>
                  )*/}
                    </List>
                  </Grid>
                  {/*<Grid item xs={12} sm={12} sx={{ paddingTop: 15 }}>
                  <center>
                    <ButtonStyle0 href="https://usamebpo.com/">
                      Salir de la ventana
                    </ButtonStyle0>
                  </center>
                </Grid>*/}
                </Grid>
              ) : showStripeForm ? (
                <StripePaymentFormAPI
                  open={showStripeForm}
                  onClose={handleStripeCancel()}
                  clientSecret={stripeClientSecret}
                  amount={rows?.total}
                  onSuccess={handleStripeSuccess}
                  onError={(error) => {
                    console.error("Stripe payment error:", error);
                    setMensageSystem("Error en el pago con Stripe");
                    setError(true);
                  }}
                />
              ) : (
                <Grid item xs={12} sm={12}>
                  <Grid
                    container
                    spacing={1}
                    className={classes.containerProfile}
                    sx={{ mt: 3 }}
                  >
                    <Grid item xs={12} sm={12}>
                      <center>
                        <Box
                          component="img"
                          src={logo}
                          alt="logo"
                          sx={{ width: 120 }}
                        ></Box>
                      </center>
                    </Grid>
                    <Grid item xs={12} sm={12} sx={{ mt: { xs: -5, sm: 2 } }}>
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          sx={{
                            borderBottom: "1px solid #ccc",
                            p: "18px 25px",
                            fontSize: 14,
                            color: "#000",
                          }}
                        >
                          <Box sx={{ float: "left" }}>
                            <b>Link de pago refencia: </b>{" "}
                            <span
                              style={{
                                background: "lavender",
                                padding: 5,
                                letterSpacing: 2,
                              }}
                            >
                              {rows.reference}
                            </span>
                          </Box>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          sx={{
                            borderBottom: "1px solid #ccc",
                            mt: 1,
                            p: "10px 0",
                            fontSize: 18,
                            textAlign: "center",
                            color: "#000",
                          }}
                        >
                          <b>TOTAL: </b> ${rows.total}
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <center>
                            <Box
                              component="img"
                              src={typeCard}
                              alt="franquicias"
                              sx={{ width: 200, my: 3 }}
                            ></Box>
                          </center>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <center>
                        <ButtonStyle0 type="submit" onClick={submitAccept}>
                          {stripeLoading
                            ? "Procesando..."
                            : `Pagar $${rows.total}`}
                        </ButtonStyle0>
                      </center>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </Grid>
      </center>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={Loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {openFrequentQuestion && (
        <FrequentQuestions
          open={openFrequentQuestion}
          exit={handleCloseFrequentQuestion}
        />
      )}
    </div>
  );
}
